import { NextRouter } from 'next/router';

import { OnboardingStep, urlLookup } from '../Layout';
import { getSessionItem } from 'src/utils/storage';

const routeWithOffer = async (step: OnboardingStep, router: NextRouter) => {
  // Add the offer param only if it exists. Gotta keep that URL tidy.
  const params: { offer?: string | string[] } = {};
  const sessionOffer = await getSessionItem('offer');

  if (router.query?.offer) {
    params.offer = router.query.offer;
  } else if (sessionOffer) {
    params.offer = sessionOffer;
  }

  router.push({
    pathname: urlLookup[step],
    query: params,
  });
};

export default routeWithOffer;
